import { Col, Input, message, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Dragger from 'antd/es/upload/Dragger';
import { t } from 'i18next';
import React from 'react';
import { InboxOutlined } from '@ant-design/icons';


const CompanyProfileCompletion = () => {
  const props = {
    name: 'file',
    multiple: true,
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };
  return (
    <>
        <Row>
          <Col span={10}>
          <div className='font-roboto-medium text-[18px] font-medium mt-3'>
            {t("LOGIN_COMPLETION:COMPANY_PROFILE")}
          </div>
          </Col>
          <Col span={4}></Col>
          <Col span={10}>
            <div className='font-roboto-medium text-[18px] font-medium mt-3'>
              {t("LOGIN_COMPLETION:COMPANY_ADDRESS")}
            </div>
          </Col>
        </Row>
  
        <Row className='mt-3'>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_LOGO")}
              </p>
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">
                  Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                  banned files.
                </p>
              </Dragger>
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_TITLE")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_COMPANY_TITLE")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COMPANY_NAME")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_EMAIL")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COMPANY_EMAIL")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_PHONE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COMPANY_PHONE")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_FAX")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COMPANY_FAX")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COMPANY_NPWP")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_COMPANY_NPWP")} )}
              />
            </div>
          </Col>
          <Col span={4}> </Col>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COUNTRY")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_COUNTRY")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_ISLAND")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_ISLAND")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_PROVINCE")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_PROVINCE")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_DISTRICT")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_DISTRICT")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_SUBDISTRICT")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_SUBDISTRICT")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_URBAN_VILLAGE")}
              </p>
              <Select 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_URBAN_VILLAGE")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_ADDRESS")}
              </p>
              <TextArea 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_ADDRESS_2")}
              </p>
              <TextArea 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS_2")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_ADDRESS_3")}
              </p>
              <TextArea 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS_3")} )}
              />
            </div>
            <div className='mt-3'>
              <Row>
                <Col span={9}>
                  <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                    {t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD_OPS")}
                  </p>
                </Col>
                <Col span={2}></Col>
                <Col span={9}>
                  <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                    {t("LOGIN_COMPLETION:LBL_HAMLET_OPS")}
                  </p>
                </Col>
                <Col span={4}></Col>
              </Row>
              <Row>
                <Col span={9}>
                  <Input 
                    style={{ width: '100%' }} 
                    size="large"
                    placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD")} )}
                  />
                </Col>
                <Col span={2}></Col>
                <Col span={9}>
                  <Input 
                    style={{ width: '100%' }} 
                    size="large"
                    placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_HAMLET")} )}
                  />
                </Col>
                <Col span={4}></Col>
              </Row>
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_POSTAL_CODE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_POSTAL_CODE")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_LONGITUDE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_LONGITUDE")} )}
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_LATITUDE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_LATITUDE")} )}
              />
            </div>
          </Col>
      </Row>
    </>
  );
};

export default CompanyProfileCompletion;